import { Scene } from 'phaser';
import * as Phaser from 'phaser';

export class Boot extends Scene {
  constructor() {
    super('Boot');
  }

  preload() {
    //  The Boot Scene is typically used to load in any assets you require for your Preloader, such as a game logo or background.
    //  The smaller the file size of the assets, the better, as the Boot Scene itself has no preloader.

    this.load.image('background', '../assets/bg.png');
    // V2 splash assets
    this.load.image('gamaru_logo', '../assets_v2/menu_v2/gamarulogo.webp');
    this.load.video('gamaru_video', '../assets_v2/menu_v2/gamaru_intro.mp4');
  }

  create() {
    // Guard against undefined entries in display lists during scene shutdown
    const displayListAny = Phaser.GameObjects.DisplayList as unknown as { __patched?: boolean };
    if (!displayListAny.__patched) {
      const proto = Phaser.GameObjects.DisplayList.prototype as unknown as {
        shutdown: () => void;
        list?: Array<Phaser.GameObjects.GameObject | undefined | null>;
      };
      proto.shutdown = function shutdownPatched(this: typeof proto): void {
        if (!Array.isArray(this.list)) {
          return;
        }
        const list = this.list.slice();
        this.list.length = 0;
        for (const entry of list) {
          if (entry && typeof entry.destroy === 'function') {
            entry.destroy();
          }
        }
      };
      displayListAny.__patched = true;
    }

    // Show Gamaru splash first, then go to Preloader
    this.scene.start('GamaruSplash');
  }
}
